import React from 'react';

import { getSrc } from '@utils/media';

import api from '..';
import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

export const useMediaList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'mediaList', api: api.media }, queryVariables, queryConfig);

  return {
    medias: queryResult.resolvedData,
    latestMedias: queryResult.latestData,
    ...queryResult,
  };
};

export const useMedia = ({ id, edited } = {}, queryConfig = {}) => {
  const { data, ...queryResult } = useQuery(['media', { id }], api.media.getById, {
    ...queryConfig,
    enabled: id,
  });

  const src = React.useMemo(() => getSrc({ media: data, edited, thumbnail: true }), [data, edited]);

  return {
    media: {
      ...data,
      src,
    },
    data: data && { ...data, src },
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: ['mediaList', 'mediaTags'] });

export const useCreateMedia = createMutation(api.media.create);
export const useUpdateMedia = createMutation(api.media.update);
export const useUpsertMedia = createMutation(api.media.upsert);
